<template>
  <div>
    <div style="font-weight:bold;">
      {{boardName}}
    </div>
    <Voltage
      v-for="(item, index) in parameters"
      :index="index"
      :key="index"
      :parameter="item"
    >
    </Voltage>
  </div>
</template>

<script>
import Voltage from './Voltage.vue';

export default {
  components: {
    Voltage,
  },

  props: {
    boardName: String,
    parameters: Object,
  },

  methods: {
  },
};
</script>
